<div class="modal-header">
  <h5 class="modal-title" i18n="@@AboutUsTitle">Impressum</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>
<div class="modal-body">
  <p i18n="@@Adress">
    CUBOS Service GmbH<br />
    Brand­gehaege 16<br />
    38444 Wolfsburg
  </p>
  <p></p>
  <p i18n="@@Phone">
    Telefon: +49 (0)53 08 – 52 11 22 55<br />
    E-Mail: <a href="mailto:info@cubos.com">info@cubos.com</a>
  </p>
  <p i18n="@@FirmInfo">
    Geschäfts­führer: Dipl.-Oec. Marc Wille<br />
    Prokura: Uta Weinert-Göbel<br />
    Regis­ter­ge­richt: Amtsge­richt Braun­schweig<br />
    Regis­ter­nummer: HRB 207126<br />
    Umsatz­steuer-Identi­fi­ka­ti­ons­nummer: DE 317053026
  </p>
  <p i18n="@@CreativeGroup">
    Konzept, Gestal­tung und Umsetzung durch (<strong><a href="https://www.ge-t.de/" target="_blank" rel="noopener noreferrer">GE-T GmbH</a></strong>)
  </p>
  <p>&nbsp;</p>
</div>

<div class="modal-footer justify-content-center">
    <button class="btn btn-yellow" id="aboutusclose" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CloseButton">Schließen</button>

</div>
